import { combineEpics, type Epic } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { arrayMove } from '@dnd-kit/sortable';
import {
  editCompetition,
  localUpdateCompetition,
  orderCompetitions,
} from '../actions';
import { groupedDailyMatches, selectedDate } from '../selectors';

const editCompetitionEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(editCompetition.match),
    withLatestFrom(state$),
    map(([action, state]) => {
      const start_time = selectedDate(state) || '';
      const competitions = groupedDailyMatches(state);
      const compEditedIndex = competitions?.findIndex(
        (comp) => comp.external_id === action.payload.external_id,
      );

      const newOrder = arrayMove(
        competitions || [],
        compEditedIndex || 0,
        action.payload.ordinal || 0,
      );

      const newOrderPayload = newOrder.map(
        ({ external_id, matches }, index) => ({
          external_id,
          start_time: matches[0]?.start_time ?? '',
          ordinal: index,
        }),
      );

      return {
        ...action,
        payload: {
          ...action.payload,
          start_time,
        },
        newOrderPayload,
      };
    }),
    mergeMap(({ payload, newOrderPayload }) => [
      localUpdateCompetition(payload),
      orderCompetitions(newOrderPayload),
    ]),
  );

export default combineEpics(editCompetitionEpic);
